import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { storeWriteSettingsAdapts, StoreWriteSettingsAdapter } from './store-write-settings.adapter';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { AzureDataLakeStoreWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/azure-data-lake-store-write-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts,
        expiryDatetime: '*'
    }
})
export class AzureDataLakeStoreWriteSettingsAdapter extends StoreWriteSettingsAdapter<
    AzureDataLakeStoreWriteSettings,
    Model.StoreWriteSettings
> {
    protected override async _toResource(model: AzureDataLakeStoreWriteSettings): Promise<Model.StoreWriteSettings> {
        const result: Model.StoreWriteSettings = await super._toResource(model);
        StoreWriteSettingsAdapter.toStoreWriteSettingsResource(model, result);
        if (result != null) {
            result.expiryDatetime = ValueAdapter.toResource(model, AzureDataLakeStoreWriteSettings.EXPIRY_DATETIME);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.StoreWriteSettings,
        copySink: CopySink
    ): Promise<AzureDataLakeStoreWriteSettings> {
        const result = await super._toModel(resource, copySink);
        StoreWriteSettingsAdapter.toStoreWriteSettingsModel(resource, result);
        if (result != null && resource != null) {
            ValueAdapter.toModel(result, AzureDataLakeStoreWriteSettings.EXPIRY_DATETIME, resource.expiryDatetime);
        }
        return result;
    }
}
